import React, { Component } from 'react';
import iconAmazon from './../resources/imgs/channel/amazon.png';
//import iconAmazonJp from './../resources/imgs/channel/amazon_jp.png';
import iconRakuten from './../resources/imgs/channel/rakuten.png';
import iconYship from './../resources/imgs/channel/yship_cloud.png';

/**
 * define image channel => call by getImageChannel
 */
const ImageChannel = {
    'amazon': <img className="icon-amazon ic-amazon" src={iconAmazon} alt='amazon' />,
    'amazon.co.jp': <img className="icon-amazon ic-amazon-jp" src={iconAmazon} alt='amazon jp' />,
    'rakuten': <img className="icon-rakuten ic-rakuten" src={iconRakuten} alt='rakuten' />,
    'y-ship cloud': <img className="icon-amazon ic-y-ship" src={iconYship} alt='Y ship Cloud' />,
}

/**
 * get image channel follow name, not image => return name
 */
export function getImageChannel(channelName) {
    let img = ImageChannel[channelName ? channelName.trim().toLowerCase() : ''];
    if (typeof img === 'undefined' || !img) {
        return channelName;
    }
    return img;
}

export const ImportType = {
    0: 'Api',
    1: 'File',
}

export const typeError = {
    "0": "Warning",
    "1": "FATAL"
}

export const settingMappingItemName = {
    ASK_ME: 1,
    WITHOUT_ASK_ME: 2,
    NEVER_UPDATE: 3
}


// WEBPACK FOOTER //
// ./src/constants/order.js